import { type PictogramIconProps } from './types';

// containers_03-01
export const TrashCanWheels = ({ color = '#657B6C' }: PictogramIconProps) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5312 21.6301H90.4695"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.716 21.6301H96.7904L94.42 15.803C94.2225 15.3091 93.7287 14.9141 93.1361 14.9141H18.8645C18.2719 14.9141 17.7781 15.2104 17.5805 15.803L15.1114 21.6301H9.18548C8.49412 21.6301 7.90153 22.3215 8.09906 23.0128L18.1731 78.7165C18.2719 79.5067 18.9633 80.0992 19.7534 80.0992H92.0497C92.8398 80.0992 93.5312 79.5067 93.6299 78.7165L103.704 23.0128C104 22.2227 103.506 21.6301 102.716 21.6301Z"
        stroke={color}
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.5929 97.0872C35.8522 97.0872 38.5188 94.4205 38.5188 91.1613C38.5188 87.902 35.8522 85.2354 32.5929 85.2354C29.3337 85.2354 26.667 87.902 26.667 91.1613C26.667 94.4205 29.3337 97.0872 32.5929 97.0872Z"
        stroke={color}
        strokeWidth="3"
      />
      <path
        d="M79.4074 97.0872C82.6666 97.0872 85.3333 94.4205 85.3333 91.1613C85.3333 87.902 82.6666 85.2354 79.4074 85.2354C76.1481 85.2354 73.4814 87.902 73.4814 91.1613C73.4814 94.4205 76.1481 97.0872 79.4074 97.0872Z"
        stroke={color}
        strokeWidth="3"
      />
    </svg>
  );
};
